<template>
  <Form :req.sync="req"></Form>
</template>

<script>
export default {
  name: 'RequestPasswordReset',
  components: {
    Form: () => import('../../components/cloud/ReqPassReset/Form.vue')
  },
  props: {
    req: Object
  }
}
</script>

<style scoped>
</style>